import { Component } from '@angular/core';

@Component({
  selector: 'app-user-profile-attachments',
  templateUrl: './user-profile-attachments.component.html',
  standalone: false,
})
export class UserProfileAttachmentsComponent {}
